import { createMuiTheme } from 'material-ui/styles';
const muiTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#1865b1',
      main: '#0a549d',
      dark: '#124679',
      contrastText: '#fff',
    },
    secondary: {
      light: '#f7f7f7f',
      main: '#ffffff',
      dark: '#eeeeee',
      contrastText: '#000',
    },
    
  },
});
export default muiTheme;


// WEBPACK FOOTER //
// ./src/component/MuiTheme.js